import { createRouter, createWebHistory } from 'vue-router'

import AdminLayout from '../layouts/AdminLayout.vue'

// Admin
import AdminHomeView from '../views/Admin/AdminHomeView.vue'

import DashboardView from '../views/Admin/DashboardView.vue'
import JobPostsView from '../views/Admin/JobPostsView.vue'
import JobPostDetailView from '../views/Admin/JobPostDetailView.vue'
import BookmarksView from '../views/Admin/BookmarksView.vue'
import CompanyNewsView from '../views/Admin/News/CompanyNewsView.vue'
import CompanyNewsPostView from '../views/Admin/News/CompanyNewsPostView.vue'
import DocumentsView from '../views/Admin/Documents/DocumentsView.vue'
import DocumentView from '../views/Admin/Documents/DocumentView.vue'
import TeamMembersView from '../views/Admin/Teams/TeamMembersView.vue'
import TraningLinksView from '../views/Admin/Training/TrainingLinksView.vue'
import ContactHumanResourcesView from '../views/Admin/HumanResources/ContactHumanResourcesView.vue'
import UpcomingKPIView from '../views/Admin/KPI/UpcomingKPIView.vue'
import KPIReportView from '../views/Admin/KPI/KPIReportView.vue'
import PerformanceReviewView from '../views/Admin/KPI/PerformanceReviewView.vue'

const routes = [
  // Auth
  {
    path: '/auth',
    name: 'auth-layout',
    component: () => import('@/layouts/AuthLayout.vue'),
    children: [
      {
        path: '/login',
        name: 'login-view',
        component: () => import('@/views/Auth/LoginView.vue')
      },
      {
        path: '/register',
        name: 'register-view',
        component: () => import('@/views/Auth/RegisterView.vue')
      },
      {
        path: '/auth/password-reset-request',
        name: 'password-reset-request-view',
        component: () =>
          import('@/views/Auth/PasswordReset/PasswordResetRequest.vue')
      },
      {
        path: '/auth/password-reset-confirmation',
        name: 'password-reset-confirmation-view',
        component: () =>
          import('@/views/Auth/PasswordReset/PasswordResetConfirmation.vue')
      },
      {
        path: '/auth/view-selection',
        name: 'view-selection',
        component: () => import('@/views/Auth/ViewSelection.vue'),
        meta: {
          auth: true
        }
      }
    ]
  },
  // Admin
  {
    path: '/admin',
    name: 'admin-layout',
    component: AdminLayout,
    meta: {
      auth: false
    },
    children: [
      {
        path: '/admin/dashboard',
        name: 'admin-dashboard-view',
        component: DashboardView
      },
      {
        path: '/admin/home',
        name: 'admin-home-view',
        component: AdminHomeView
      },
      {
        path: '/admin/job-posts',
        name: 'admin-job-posts-view',
        component: JobPostsView
      },
      {
        path: '/admin/job-posts/:id',
        name: 'admin-job-post-detail-view',
        component: JobPostDetailView
      },
      {
        path: '/admin/bookmarks',
        name: 'admin-bookmarks-view',
        component: BookmarksView
      },

      {
        path: '/admin/company-news',
        name: 'admin-company-news',
        component: CompanyNewsView
      },
      {
        path: '/admin/company-news-post/:id',
        name: 'admin-company-news-post',
        component: CompanyNewsPostView
      },
      {
        path: '/admin/documents',
        name: 'admin-documents-view',
        component: DocumentsView
      },
      {
        path: '/admin/document/:id',
        name: 'admin-document-view',
        component: DocumentView
      },
      {
        path: '/admin/team-members',
        name: 'admin-team-members-view',
        component: TeamMembersView
      },
      {
        path: '/admin/training-links',
        name: 'training-links',
        component: TraningLinksView
      },
      {
        path: '/admin/human-resources',
        name: 'admin-human-resources',
        component: ContactHumanResourcesView
      },
      {
        path: '/admin/upcoming-kpi',
        name: 'admin-upcoming-kpi-view',
        component: UpcomingKPIView
      },
      {
        path: '/admin/kpi-reports',
        name: 'admin-kpi-report',
        component: KPIReportView
      },
      {
        path: '/admin/performance-review',
        name: 'admin-performance-review',
        component: PerformanceReviewView
      }
    ]
  },
  // Website
  {
    path: '/',
    name: 'website-layout',
    component: () => import('@/layouts/WebsiteLayout.vue'),
    children: [
      {
        path: '/',
        name: 'home-view',
        component: () => import('@/views/Website/HomeView.vue')
      },
      {
        path: '/about',
        name: 'about-view',
        component: () => import('@/views/Website/AboutView.vue')
      },
      {
        path: '/contact',
        name: 'contact-view',
        component: () => import('@/views/Website/ContactView.vue')
      },
      {
        path: '/privacy-policy',
        name: 'privacy-policy-view',
        component: () => import('@/views/Website/PrivacyPolicyView.vue')
      },
      {
        path: '/terms-and-conditions',
        name: 'terms-and-conditions-view',
        component: () => import('@/views/Website/TermsAndConditionsView.vue')
      },
      // Job Portal Routes
      {
        path: '/jobs',
        name: 'jobs-view',
        component: () => import('@/views/Website/JobsView.vue')
      },
      {
        path: '/jobs/:id',
        name: 'job-detail-view',
        component: () => import('@/views/Website/JobDetailView.vue')
      },
      {
        path: '/post-job',
        name: 'post-job-view',
        component: () => import('@/views/Website/PostJobView.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/profile',
        name: 'profile-view',
        component: () => import('@/views/Website/ProfileView.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/resume',
        name: 'resume-view',
        component: () => import('@/views/Website/ResumeView.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/career-advice',
        name: 'career-advice-view',
        component: () => import('@/views/Website/CareerAdviceView.vue')
      },
      {
        path: '/employer-guide',
        name: 'employer-guide-view',
        component: () => import('@/views/Website/EmployerGuideView.vue')
      },
      {
        path: '/blog',
        name: 'blog-view',
        component: () => import('@/views/Website/BlogView.vue')
      },
      {
        path: '/careers',
        name: 'careers-view',
        component: () => import('@/views/Website/CareersView.vue')
      },
      {
        path: '/community',
        name: 'community-view',
        component: () => import('@/views/Website/CommunityView.vue')
      },
      {
        path: '/career-development-services',
        name: 'career-development-services-view',
        component: () => import('@/views/Website/CareerDevelopmentServicesView.vue')
      }
    ]
  },
  // Common
  {
    path: '/not-authorised',
    name: 'not-authorised',
    component: () => import('@/views/NotAuthorised.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: () => import('@/views/PageNotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkActiveClass: 'active',
  routes
})

export default (app) => {
  app.router = router
  app.use(router)
}
